<template>
	<Modal @close="closeModal()" :modalWidth="18" :draggable="false">
		<template slot="title">Customer Statement Criteria</template>
		<template slot="body">
			<table class="view_tbl">
				<colgroup>
					<col style="width: 10%;" />
					<col style="width: 90%;" />
				</colgroup>
				<tbody>
					<tr>
						<th><input type="checkbox" id="credit" v-model="credit" @change="changeShowCredit" /></th>
						<td><label for="credit">Show All Credit</label></td>
					</tr>
					<tr>
						<th><input type="checkbox" :disabled="true" checked /></th>
						<td>Show Balance</td>
					</tr>
					<tr>
						<th><input type="checkbox" id="PDC" v-model="post_dated_check" @change="changeShowPDC" /></th>
						<td><label for="PDC">Show Post Dated Check</label></td>
					</tr>
					<tr>
						<th><input type="checkbox" id="payment" v-model="payment" :disabled="payment_required" @change="changeShowPayment" /></th>
						<td>
							<label class="mgr_5" for="payment">Show Payment</label>
							<span v-if="payment">
								<em class="lt_text">From Date</em>
								<span class="int_type_no_border">
									<input type="text" class="ssm_int" v-model.trim="payment_date" @input="changePaymentDate" placeholder="MM-DD-YYYY" @focus="$event.target.select()" @blur="isValidDate" @keyup.enter="validateDateAndPrint" />
								</span>
							</span>
						</td>
					</tr>
				</tbody>
			</table>
			<div class="popup_bottom">
				<a href="javascript:;" @click="printCustomerStatement()" class="search_bt">Print</a>
				<a href="javascript:;" @click="closeModal()" class="gray_bt">Close</a>
			</div>
		</template>
	</Modal>
</template>

<script>
import Modal from '@/components/common/Modal';
import { isDate } from '@/utils/date.js';
export default {
	data: () => ({
		credit: null,
		post_dated_check: null,
		payment: null,
		payment_date: null,
	}),
	components: {
		Modal,
	},
	props: {
		show_credit: {
			type: Boolean,
			default: false,
		},
		show_PDC: {
			type: Boolean,
			default: false,
		},
		show_payment: {
			type: Boolean,
			default: false,
		},
		payment_required: {
			type: Boolean,
			default: false,
		},
		init_payment_date: {
			type: String,
			default: null,
		},
	},
	methods: {
		closeModal() {
			this.$emit('close');
		},
		printCustomerStatement() {
			this.closeModal();
			this.$emit('printStatement');
		},
		changeShowCredit() {
			this.$emit('change_show_credit', this.credit);
		},
		changeShowPDC() {
			this.$emit('change_show_PDC', this.post_dated_check);
		},
		changeShowPayment() {
			this.$emit('change_show_payment', this.payment);
		},
		changePaymentDate() {
			if (this.payment_date.length < 10) return;
			else if (!isDate(this.payment_date)) this.$toast.error('Not Valid Date.');
			else this.$emit('change_payment_date', this.payment_date);
		},
		isValidDate() {
			if (!isDate(this.payment_date)) {
				this.payment_date = this.init_payment_date;
				this.$emit('change_payment_date', this.payment_date);
				this.$toast.error('Not Valid Date.');
			}
		},
		validateDateAndPrint(event) {
			if (!isDate(this.payment_date)) {
				this.$toast.error('Not Valid Date.');
				event.target.select();
			} else {
				this.changePaymentDate();
				this.printCustomerStatement();
			}
		},
	},
	created() {
		this.credit = this.show_credit;
		this.post_dated_check = this.show_PDC;
		this.payment = this.payment_required || this.show_payment;
		this.payment_date = this.init_payment_date;
	},
};
</script>

<style></style>
